import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { DialogState } from './types';

export const actions: ActionTree<DialogState, RootState> = {
  /**
   * @param { commit }: actions에서는 mutations를 fetch하기 위한 commit method를 참조로서 제공한다.
   * @param payload: 참조된 commit method 다음부터는 인수를 받을 수 있다.
   */
  showConfirm({ commit }, payload): void {
    commit('dialogTypeConfirm', payload);
  },
  showAlert({ commit }, payload): void {
    commit('dialogTypeAlert', payload);
  },
  closeDialog({ commit }, payload): void {
    commit('dialogClose', payload);
  }
};
